// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"67":"1f32d583","193":"b2a7e7c3"}[chunkId] + ".chunk.js";
};